import CheckboxInput from 'components/forms/inputs/rhf-inputs/CheckboxInput';
import DateInput from 'components/forms/inputs/rhf-inputs/DateInput';
import SelectInput from 'components/forms/inputs/rhf-inputs/SelectInput';
import TextAreaInput from 'components/forms/inputs/rhf-inputs/TextAreaInput';
import { useLazyGetMinOfficesWithFiltersQuery } from 'store/api/offices';
import { getValidOptionsFromClassifier } from 'utils/formUtil';
import { officeInactiveSuffix } from 'utils/officeOptionRenderer';
import DynamicSelectInput from 'components/forms/inputs/rhf-inputs/DynamicSelectInput';
import InfoTooltip from 'components/InfoTooltip';
import { MatterFormState } from './useMatterForm';

/** Archiving. */
export const ArchivingFields = ({ form }: { form: MatterFormState }): JSX.Element => {
    const { control, setValue } = form.methods;
    const { classifiers } = form;

    return (
        <>
            <CheckboxInput
                control={control}
                name="isAutomaticClosingExempt"
                label="matters.exempt-from-automatic-closing"
            />
            <CheckboxInput
                control={control}
                name="isPaperFile"
                label="matters.paper-file-exists"
                tooltip={<InfoTooltip text="matters.tooltips.paper-file-exists" />}
            />
            <DateInput
                control={control}
                label="matters.archiving-date"
                placeholder="forms.select-date"
                name="archivedDate"
            />
            <DynamicSelectInput
                setValue={setValue}
                control={control}
                label="matters.archived-in-office"
                placeholder="matters.select-office"
                name="archivedInOffice"
                paginated={{
                    fetch: useLazyGetMinOfficesWithFiltersQuery,
                    searchField: 'name',
                    filters: 'isActive!=false',
                }}
                getOptionLabel="name"
                getOptionIdentifier="id"
                getOptionEndAdornment={officeInactiveSuffix}
            />
            <SelectInput
                setValue={setValue}
                control={control}
                label="matters.archiving-properties"
                placeholder="matters.select-archiving-properties"
                name="archivingPropertiesType"
                options={
                    (getValidOptionsFromClassifier(classifiers['ARCHIVING_PROPERTIES_TYPE']) as {
                        label: string;
                        value: string;
                    }[]) ?? []
                }
                getOptionLabel="label"
                getOptionIdentifier="value"
            />
            <TextAreaInput
                control={control}
                label="matters.archiving-notes"
                placeholder="matters.archiving-notes"
                name="archivingNotes"
                enableAutofill
            />
        </>
    );
};
